import styled from '@emotion/styled'

import { ArcadeColors, useGetArcadeColor } from '../../theme/arcadeColors'
import { avatarSizeDimensions } from '../Avatar/ArcadeAvatar'

type CircleVariantProps = {
  color: ArcadeColors
  backgroundColor: ArcadeColors
}

type CircleProps = CircleVariantProps & {
  size: string
}

const Circle = styled.div<CircleProps>`
  color: ${props => useGetArcadeColor(props.color)};
  background: ${props => useGetArcadeColor(props.backgroundColor)};
  border-radius: 50%;
  width: ${props => props.size};
  height: ${props => props.size};
  display: grid;
  place-items: center;
`

type Variant = 'tint' | 'danger' | 'inverse' | 'subtle'
type Size = 'xsmall' | 'small' | 'medium'

export interface ArcadeIconMatProps {
  variant?: Variant
  size?: Size
  children?: React.ReactNode
}

/**
 * A background fill intended to underlay an icon, to be frequently used with Arcade icons.
 * Assumes child icon inherits its fill from `currentColor`, and is is appropriately sized where
 *
 * - size of "xsmall" assumes a 16x16 icon
 * - size of "small" assumes a 24x24 icon
 * - size of "medium" (default) assumes a 32x32 icon
 */
export const ArcadeIconMat = ({ variant = 'tint', size = 'medium', children }: ArcadeIconMatProps) => {
  const arcadeVariants: Record<Variant, CircleVariantProps> = {
    tint: {
      color: 'iconInverse',
      backgroundColor: 'iconBrand',
    },
    danger: {
      color: 'iconInverse',
      backgroundColor: 'iconDanger',
    },
    inverse: {
      color: 'iconInverse',
      backgroundColor: 'iconStandard',
    },
    subtle: {
      color: 'iconSubtle',
      backgroundColor: 'backgroundSubtle',
    },
  }
  return (
    <Circle {...arcadeVariants[variant]} size={avatarSizeDimensions[size].rem}>
      {children}
    </Circle>
  )
}
